import React, {useState, useEffect} from "react";
import {getCookie} from "../../../../auth/helpers";
import {AppBar, Toolbar} from "@material-ui/core";
import {useForm} from "react-hook-form";
import axios from "axios";
import NestedTable from "./NestedTable.js";

const AddFormDialog = (props) => {
  const token = getCookie("token");
  const {register, handleSubmit} = useForm();
  const [books, setBooks] = useState([]);
  const [grades, setGrades] = useState([]);

  useEffect(() => {
    setBooks(props.formValues.books);
  }, []);

  const handleOnSubmit = async (data) => {
    if (props.title.substring(0, 4) === "Edit") {
      await axios({
        method: "put",
        url: `${
          window?.location?.hostname?.includes("maroc")
            ? process.env.REACT_APP_API_MAROC
            : process.env.REACT_APP_API
        }/students/${props.formValues.serial}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {...data, books},
      })
        .then((response) => {
          props.handleClose();
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      await axios({
        method: "post",
        url: `${
          window?.location?.hostname?.includes("maroc")
            ? process.env.REACT_APP_API_MAROC
            : process.env.REACT_APP_API
        }/students`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {...data, books},
      })
        .then((response) => {
          props.handleClose();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  return (
    <>
      <AppBar className="position-relative">
        <Toolbar>
          <button type="button" className="close" onClick={props.handleClose}>
            &times;
          </button>
          <h4 className="text-white mx-3 my-0">{props.title}</h4>
        </Toolbar>
      </AppBar>
      <div style={{padding: "50px"}}>
        <form onSubmit={handleSubmit(handleOnSubmit)} encType="multipart/form-data">
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  placeholder="Name"
                  {...register("name")}
                  defaultValue={props.formValues.name}
                />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="text"
                  className="form-control"
                  id="email"
                  placeholder="Email"
                  {...register("email")}
                  defaultValue={props.formValues.email}
                />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  placeholder="Password"
                  {...register("password")}
                  defaultValue={props.formValues.password}
                />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="school">School</label>
                <input
                  type="text"
                  className="form-control"
                  id="school"
                  placeholder="School"
                  {...register("school")}
                  defaultValue={props.formValues.school}
                />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="phone">Phone</label>
                <input
                  type="text"
                  className="form-control"
                  id="phone"
                  placeholder="Phone"
                  {...register("phone")}
                  defaultValue={props.formValues.phone}
                />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="ml-4 form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="verified"
                  defaultChecked={props.formValues.verified ? true : false}
                  {...register("verified")}
                />
                <label className="form-check-label" htmlFor="verified">
                  Verified
                </label>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="notes">Notes</label>
                <textarea
                  className="form-control"
                  id="notes"
                  rows="3"
                  {...register("notes")}
                  defaultValue={props.formValues.notes}
                ></textarea>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group">
                <NestedTable
                  arrayName={books}
                  setArrayName={setBooks}
                  title="Books"
                  dbTable="books"
                  setGrades={setGrades}
                />
              </div>
            </div>
            <div className="col-12 d-flex flex-row-reverse">
              <button type="button" className="btn btn-lg btn-primary" type="submit">
                <i className="fas fa-save"></i> Save
              </button>{" "}
              &nbsp;&nbsp;
              <button type="button" className="btn btn-lg btn-secondary" onClick={props.handleClose}>
                <i className="fas fa-times"></i> Close
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddFormDialog;
